import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-line-chart',
  imports: [
    CommonModule,
    NgxChartsModule
  ],
  templateUrl: './line-chart.component.html',
  styleUrl: './line-chart.component.scss'
})
export class LineChartComponent {
  @Input() ourMethodologyData: any[] = [];
  @Input() customWidth: number | null = null;
  @Input() customHeight: number | null = null;
  @Input() xAxisTickValues: any[] = [];

  // view: [number, number] = [1200, 500];
  view: any = [window.innerWidth * 0.7, window.innerHeight * 0.7];
  // showLegend = true;

  get chartView(): [number, number] {
    // If custom dimensions provided, use them; otherwise use default [700, 400]
    return [
      this.customWidth || 700,
      this.customHeight || 400
    ];
  }

}
